import { render, staticRenderFns } from "./KeyboardPro.vue?vue&type=template&id=3f7d7bec&scoped=true&"
import script from "./KeyboardPro.vue?vue&type=script&lang=js&"
export * from "./KeyboardPro.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardPro.vue?vue&type=style&index=0&id=3f7d7bec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7d7bec",
  null
  
)

export default component.exports